// extracted by mini-css-extract-plugin
module.exports = {"More":"styles-module--More--2gOLz","More__text":"styles-module--More__text--18lRM"};